import { usePunditUserContext } from "@/react/contexts/punditUserContext";

const MAY_LEAD_TO_PURCHASE_ATTRIBUTE = "data-may-lead-to-purchase";

const useHasPlusPlan = () => {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(currentCommunity?.has_plus_plan);
};

export const useCanMarkPurchaseFlow = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const hasPlusPlan = useHasPlusPlan();

  return (
    hasPlusPlan &&
    Boolean(currentCommunitySettings?.circle_plus_purchase_flow_cta_enabled)
  );
};

const purchaseFlowAnchorProps = (mayLeadToPurchase?: boolean) =>
  mayLeadToPurchase === true
    ? { [MAY_LEAD_TO_PURCHASE_ATTRIBUTE]: "true" }
    : {};

export const usePurchaseFlowAnchorProps = (mayLeadToPurchase?: boolean) => {
  const canMarkPurchaseFlow = useCanMarkPurchaseFlow();

  return purchaseFlowAnchorProps(canMarkPurchaseFlow && mayLeadToPurchase);
};
